import * as React from "react";
import classnames from "classnames";
import {
    LazyLoadImage,
    LazyLoadComponent,
} from "react-lazy-load-image-component";
import $ from "./Image.module.scss";

interface Props {
    src: string;
    placeholder?: string;
    background?: boolean;
    alt?: string;
    style?: React.CSSProperties;
    className?: string;
}

const Image = (props: Props) => {
    const { placeholder, src, background, alt, style, className } = props;
    const [isLoaded, setIsLoaded] = React.useState(false);
    const blur = 65;

    if (background) {
        return (
            <LazyLoadComponent>
                <div
                    title={alt}
                    className={classnames($.backgroundImage, className)}
                    style={{
                        ...style,
                        backgroundImage: `url("${isLoaded ? src : placeholder || ""}")`,
                        filter:
                            !isLoaded && placeholder
                                ? `blur(${blur}px)`
                                : "none",
                    }}
                    data-testid="backgroundimage"
                >
                    {placeholder && (
                        <noscript>
                            <img
                                src={src}
                                alt={alt}
                                data-testid="noscriptimage"
                            />
                        </noscript>
                    )}
                    <img
                        src={src}
                        alt=""
                        className={$.image}
                        onLoad={() => setIsLoaded(true)}
                    />
                </div>
            </LazyLoadComponent>
        );
    }

    return (
        <LazyLoadImage
            src={src}
            placeholderSrc={placeholder}
            alt={alt}
            title={alt}
            className={className}
            style={{
                ...style,
                filter: placeholder && !isLoaded ? `blur(${blur}px)` : "none",
                transition: "filter 0.25s ease",
            }}
            data-testid="image"
            onLoad={() => setIsLoaded(true)}
        />
    );
};

export default Image;
